import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const Receipt = () =>{
  return(
   <DocumentDetails documentType={'receipts'} keyAccess={'HawkAI-BankCheque'} title={'Receipt'} exportDataToExcelName={'Receipts Document'} analysefrom={'receipt'} deleteText={'receipt'} modelName={'doc-ai'} webSocketName={'receipt'}/>
  )
 };
 export default Receipt;